export enum ProtectedFieldValueType {
  AdHocTraining = 11,
  DocumentTraining = 12,
  DepartmentType_Department = 13,
  DepartmentType_Entity = 14,
  DepartmentType_UserGroup = 15,
  AiResponseSuccess = 31,
  AiResponseFailure = 32,

  ChkResultClassCanvas = 33,
  ChkResultClassNumeric = 34,
  ChkResultClassSingleChoice = 35,
  ChkResultClassText = 36,
  ChkResultClassHtml = 40,

  ChkOutcomeTypeUnknown = 37,
  ChkOutcomeTypePositive = 38,
  ChkOutcomeTypeNegative = 39,
  ChkOutcomeTypeNC = 40,
  ChkOutcomeTypeNA = 41,
  QualificationExpiryNever = 42,
  QualificationExpiryAfter = 43,
  SkillGradeNone = 44,
  SkillGradeNovice = 45,
  SkillGradeAdvancedBeginner = 46,
  SkillGradeIntermediate = 47,
  SkillGradeProficient = 48,
  SkillGradeExpert = 49,
  SkillQualificationNone_None = 50,
  SkillQualificationNone_Skill = 51,
  SkillQualificationNone_Qualification = 52,
  // Option: Training
  UserQualificationFrom_Training = 53,
  // Option: Exam
  UserQualificationFrom_Exam = 54,
  // Option: Document (Read and understand)
  UserQualificationFrom_Document = 55,
  // Option: Manuel (Matrix)
  UserQualificationFrom_Manual = 56,
  // Option: Exemption (Qualification has inner linked qualifications)
  UserQualificationFrom_Exemption = 57,
  SignatureDisabled = 58,
  SignatureEnabled = 59,
  SignatureRequired = 60,
}